/**
 *
 * @param oldVal array of objects before change (assumed to contain unique elements)
 * @param newVal array of objects after change
 * @param discriminatorKey key of property to base equality check of array elements on
 * @returns true if array contains unique elements after change, false otherwise
 */
function isArrayUniqueChange<T extends Record<string, any>, K extends keyof T>(
  oldVal: T[],
  newVal: T[],
  discriminatorKey: K,
) {
  const lastItem = newVal[newVal.length - 1];
  return newVal.length <= oldVal.length || !oldVal.some((elm) => elm[discriminatorKey] === lastItem);
}

export default isArrayUniqueChange;
